import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { provideAnimations } from '@angular/platform-browser/animations';


import { AdminRoutingModule } from './admin-routing.module';
import { AdminDashboardComponent } from './dashboard/admin-dashboard/admin-dashboard.component';
import { AdminModalComponent } from './modals/admin-modal/admin-modal.component';
import { UsersManagementComponent } from './pages/back-office/users-management/users-management.component';
import { SupportComponent } from './pages/back-office/support/support.component';
import { RoleManagementComponent } from './pages/role-management/role-management/role-management.component';
import { RoleModalComponent } from './pages/role-management/role-modal/role-modal.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { RoleManagementLandingComponent } from './pages/role-management/role-management-landing/role-management-landing.component';
import { PrivilegeManagementComponent } from './pages/role-management/privilege-management/privilege-management.component';
import { CreatePrivilegeComponent } from './pages/role-management/create-privilege/create-privilege.component';
import { NgbModule, NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../shared/shared.module';
import { UpdateRoleComponent } from './pages/role-management/update-role/update-role.component';
import { SuperAgentManagementLandingComponent } from './pages/super-agent-management/super-agent-management-landing/super-agent-management-landing.component';
import { CreateSuperAgentComponents } from './pages/super-agent-management/create-super-agent/create-super-agent.component';
import { LottieComponent, provideLottieOptions } from 'ngx-lottie';
import player from 'lottie-web';
import { TicketGenerationLandingComponent } from './pages/ticketing/ticket-generation-landing/ticket-generation-landing.component';
import { GenerateTicketModalComponent } from './pages/ticketing/generate-ticket-modal/generate-ticket-modal.component';
import { ETicketListComponent } from './pages/ticketing/e-ticket-list/e-ticket-list.component';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { AllTransactionHistoryComponent } from './pages/transactions/all-transaction-history/all-transaction-history.component';
import { SuperAgentDetailsModalComponent } from './pages/super-agent-management/super-agent-details-modal/super-agent-details-modal.component';
import { TaxpayerLandingComponent } from './pages/taxpayer/taxpayer-landing/taxpayer-landing.component';
import { TaxpayerModalComponent } from './pages/taxpayer/taxpayer-modal/taxpayer-modal.component';
import { AdminManagementLandingComponent } from './pages/admin-management/admin-management-landing/admin-management-landing.component';
import { CreateAdminComponent } from './pages/admin-management/create-admin/create-admin.component';
import { AdminDetailsModalComponent } from './pages/admin-management/admin-details-modal/admin-details-modal.component';
import { IgrAssessmentLandingComponent } from './pages/igr-services/igr-assessment/igr-assessment-landing/igr-assessment-landing.component';
import { IgrAssessmentAsinVerificationModalComponent } from './pages/igr-services/igr-assessment/igr-assessment-asin-verification-modal/igr-assessment-asin-verification-modal.component';
import { IgrAssessmentDetailsComponent } from './pages/igr-services/igr-assessment/igr-assessment-modal/igr-assessment-details/igr-assessment-details.component';
import { IgrAssessmentApplicationModalComponent } from './pages/igr-services/igr-assessment/igr-assessment-application-modal/igr-assessment-application-modal.component';
import { WorkflowCreateComponent } from './pages/workflow/workflow-create/workflow-create.component';
import { WorkflowLandingComponent } from './pages/workflow/workflow-landing/workflow-landing.component';
import { WorkflowDetailsComponent } from './pages/workflow/workflow-details/workflow-details.component';
import { LgaIdentificationLandingComponent } from './pages/non-igr-services/lga-identification/lga-identification-landing/lga-identification-landing.component';
import { LgaIdentificationApplicationComponent } from './pages/non-igr-services/lga-identification/lga-identification-application/lga-identification-application.component';
import { LgaIdentificationDetailsComponent } from './pages/non-igr-services/lga-identification/lga-identification-details/lga-identification-details.component';
import { LgaSettingsComponent } from './pages/lga-settings/lga-settings/lga-settings.component';
import { LgaSettingsModalComponent } from './pages/lga-settings/lga-settings-modal/lga-settings-modal.component';


import { VehicleTypeLandingComponent } from './pages/vehicle-type/vehicle-type-landing/vehicle-type-landing.component';
import { VehicleTypeCreateComponent } from './pages/vehicle-type/vehicle-type-create/vehicle-type-create.component';
import { MotorParkLandingComponent } from './pages/motor-park/motor-park-landing/motor-park-landing.component';
import { MotorParkCreateComponent } from './pages/motor-park/motor-park-create/motor-park-create.component';
import { StreetNamingLandingComponent } from './pages/non-igr-services/street-naming/street-naming-landing/street-naming-landing.component';
import { StreetNamingDetailsModalComponent } from './pages/non-igr-services/street-naming/street-naming-details-modal/street-naming-details-modal.component';
import { StreetNamingApplicationComponent } from './pages/non-igr-services/street-naming/street-naming-application/street-naming-application.component';
import { BirthRegistrationLandingComponent } from './pages/non-igr-services/birth-registration/birth-registration-landing/birth-registration-landing.component';
import { BirthRegistrationApplicationComponent } from './pages/non-igr-services/birth-registration/birth-registration-application/birth-registration-application.component';
import { BirthRegistrationDetailsModalComponent } from './pages/non-igr-services/birth-registration/birth-registration-details-modal/birth-registration-details-modal.component';
import { MarriageRegistrationLandingComponent } from './pages/non-igr-services/marriage-registration/marriage-registration-landing/marriage-registration-landing.component';
import { MarriageRegistrationApplicationComponent } from './pages/non-igr-services/marriage-registration/marriage-registration-application/marriage-registration-application.component';
import { MarriageRegistrationDetailsModalComponent } from './pages/non-igr-services/marriage-registration/marriage-registration-details-modal/marriage-registration-details-modal.component';
import { DeathRegistrationApplicationComponent } from './pages/non-igr-services/death-registration/death-registration-application/death-registration-application.component';
import { DeathRegistrationLandingComponent } from './pages/non-igr-services/death-registration/death-registration-landing/death-registration-landing.component';
import { DeathRegistrationDetailsModalComponent } from './pages/non-igr-services/death-registration/death-registration-details-modal/death-registration-details-modal.component';
import { SummaryDashboardComponent } from './dashboard/summary-dashboard/summary-dashboard.component';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatCardModule} from '@angular/material/card';
import { provideNativeDateAdapter } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { AssetManagementDashboardComponent } from './asset-management/asset-management-dashboard/asset-management-dashboard.component';
import { TransportAssetLandingComponent } from './asset-management/modules/transport/transport-asset-landing/transport-asset-landing.component';
import { TransportAssetDetailsPageComponent } from './asset-management/modules/transport/transport-asset-details-page/transport-asset-details-page.component';
import { TransportAssetDetailsModalComponent } from './asset-management/modules/transport/transport-asset-details-modal/transport-asset-details-modal.component';
import { PropertyAssetDetailsPageComponent } from './asset-management/modules/property/property-asset-details-page/property-asset-details-page.component';
import { PropertyAssetLandingComponent } from './asset-management/modules/property/property-asset-landing/property-asset-landing.component';
import { MarketAssetLandingComponent } from './asset-management/modules/market/market-asset-landing/market-asset-landing.component';
import { MarketAssetDetailsModalComponent } from './asset-management/modules/market/market-asset-details-modal/market-asset-details-modal.component';
import { MarketAssetDetailsPageComponent } from './asset-management/modules/market/market-asset-details-page/market-asset-details-page.component';
import { PropertyAssetDetailsModalComponent } from './asset-management/modules/property/property-asset-details-modal/property-asset-details-modal.component';
import { CollectionsLandingComponent } from './collections-landing/collections-landing.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { CouponLandingComponent } from './pages/coupon/coupon-landing/coupon-landing.component';
import { GenerateCouponModalComponent } from './pages/coupon/generate-coupon-modal/generate-coupon-modal.component';
import { ManualReconciliationComponent } from './pages/reconciliation/manual-reconciliation/manual-reconciliation.component';
import { TicketsSoldLandingComponent } from './pages/tickets-sold/tickets-sold-landing/tickets-sold-landing.component';
import { AdditionalIgrAssessmentModalComponent } from './pages/igr-services/igr-assessment/additional-igr-assessment-modal/additional-igr-assessment-modal.component';
import { PerformanceReportDashboardComponent } from './dashboard/performance-report-dashboard/performance-report-dashboard.component';
import { AssessmentReportDashboardComponent } from './dashboard/assessment-report-dashboard/assessment-report-dashboard.component';
import { WorkflowUpdateComponent } from './pages/workflow/workflow-update/workflow-update.component';

@NgModule({
  declarations: [
    AdminDashboardComponent,
    AdminModalComponent,
    UsersManagementComponent,
    SupportComponent,
    RoleManagementComponent,
    RoleModalComponent,
    RoleManagementLandingComponent,
    PrivilegeManagementComponent,
    CreatePrivilegeComponent,
    UpdateRoleComponent,
    SuperAgentManagementLandingComponent,
    CreateSuperAgentComponents,
    TicketGenerationLandingComponent,
    GenerateTicketModalComponent,
    ETicketListComponent,
    AllTransactionHistoryComponent,
    SuperAgentDetailsModalComponent,
    TaxpayerLandingComponent,
    TaxpayerModalComponent,
    AdminManagementLandingComponent,
    CreateAdminComponent,
    AdminDetailsModalComponent,
    IgrAssessmentLandingComponent,
    IgrAssessmentAsinVerificationModalComponent,
    IgrAssessmentDetailsComponent,
    IgrAssessmentApplicationModalComponent,
    AdditionalIgrAssessmentModalComponent,
    WorkflowLandingComponent,
    WorkflowCreateComponent,
    WorkflowUpdateComponent,
    LgaIdentificationLandingComponent,
    LgaIdentificationApplicationComponent,
    LgaIdentificationDetailsComponent,
    WorkflowDetailsComponent,
    LgaSettingsComponent,
    LgaSettingsModalComponent,
    VehicleTypeLandingComponent,
    VehicleTypeCreateComponent,
    MotorParkLandingComponent,
    MotorParkCreateComponent,
    StreetNamingLandingComponent,
    StreetNamingDetailsModalComponent,
    StreetNamingApplicationComponent,
    BirthRegistrationLandingComponent,
    BirthRegistrationApplicationComponent,
    BirthRegistrationDetailsModalComponent,
    MarriageRegistrationLandingComponent,
    MarriageRegistrationApplicationComponent,
    MarriageRegistrationDetailsModalComponent,
    DeathRegistrationApplicationComponent,
    DeathRegistrationLandingComponent,
    DeathRegistrationDetailsModalComponent,
    SummaryDashboardComponent,
    PerformanceReportDashboardComponent,
    AssessmentReportDashboardComponent,
    AssetManagementDashboardComponent,
    TransportAssetLandingComponent,
    TransportAssetDetailsPageComponent,
    TransportAssetDetailsModalComponent,
    PropertyAssetDetailsPageComponent,
    PropertyAssetLandingComponent,
    MarketAssetLandingComponent,
    MarketAssetDetailsModalComponent,
    MarketAssetDetailsPageComponent,
    PropertyAssetDetailsModalComponent,
    CollectionsLandingComponent,
    CouponLandingComponent,
    GenerateCouponModalComponent,
    ManualReconciliationComponent,
    TicketsSoldLandingComponent,
    
  ],

  imports: [
    CommonModule,
    AdminRoutingModule,
    NgSelectModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    NgbModule,
    NgbPaginationModule,
    LottieComponent,
    NgxSkeletonLoaderModule,
    NgxChartsModule,
    MatDatepickerModule,
    MatFormFieldModule,

  ],

  providers: [
    provideLottieOptions({
      player: () => player,
    }),
    provideNativeDateAdapter(),
  ],
  exports: [NgbPaginationModule],
})
export class AdminModule {}
